<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="140px" class="demo-ruleForm">
    <el-form-item label="床位名" prop="bed_name">
      <el-input v-model="addEditForm.bed_name" placeholder="请输入床位名"></el-input>
    </el-form-item>
    <el-form-item label="床位号" prop="bed_num">
      <el-input disabled type="number" v-model="addEditForm.bed_num" placeholder="请输入床位号"></el-input>
    </el-form-item>
    <el-form-item label="床位费" prop="bed_fee">
      <el-input type="number" v-model="addEditForm.bed_fee" placeholder="请输入床位费"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createhomebed, updatehomebed} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditBed',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    bedRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        id: 0,
        hid: '',
        bed_name: '',
        bed_num: '',
        bed_fee: '',
        bed_remark_name: ''
      },
      addEditRules: {
        bed_name: [
          {required: true, message: '请输入床位名', trigger: 'blur'}
        ],
        bed_num: [
          {required: true, message: '请输入床位号', trigger: 'blur'}
        ],
        bed_fee: [
          {required: true, message: '请输入床位费', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.addEditForm.hid = this.bedRow.roomRow.id
    if (!this.bedRow.isAdd) {
      this.addEditForm.id = this.bedRow.row.id
      this.addEditForm.bed_name = this.bedRow.row.bed_name
      this.addEditForm.bed_num = this.bedRow.row.bed_num
      this.addEditForm.bed_fee = this.bedRow.row.bed_fee
      this.addEditForm.bed_remark_name = this.bedRow.row.bed_remark_name
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: parseInt(this.addEditForm.id),
            hid: parseInt(this.addEditForm.hid),
            bed_name: this.addEditForm.bed_name,
            bed_num: parseInt(this.addEditForm.bed_num),
            bed_fee: parseFloat(this.addEditForm.bed_fee),
            bed_remark_name: this.addEditForm.bed_remark_name
          }
          data.bed_remark_name = this.bedRow.roomRow.room + '-' + data.bed_num
          if (this.bedRow.isAdd) {
            createhomebed(data).then(res => {
              this.$notify({title: '成功', message: '成功新增床位', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updatehomebed(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑床位', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditBed.vue